<template>
  <header>
    <h1>Reset password</h1>
  </header>
  <div>
    <form @submit.prevent="submitForm">

      <div v-show="false" class="form-group">
        <label for="username">Username</label>
        <input type="text" class="form-control" v-model="username" id="username" autocomplete="username">
      </div>


      <div class="form-group mb-3">
        <label for="new_password" class="form-label">New Password</label>
        <input
            autocomplete="new-password"
            class="form-control"
            id="new_password" ref="new_password"
            required
            :type="showPassword?'text':'password'"
            v-model="newPassword"
        />
        <div v-if="newPasswordValidationError" class="text-danger">{{ newPasswordValidationError }}</div>
      </div>

      <button type="button" @click="togglePasswordVisibility" class="btn btn-secondary me-3">
        {{ showPassword ? 'Hide password' : 'Show password' }}
      </button>
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
  </div>
</template>

<script>
import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";

export default {
  name: "ConfirmPasswordResetPage",
  props: {
    userId: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userName: '',
      newPassword: '',
      showPassword: false,
    };
  },
  mounted() {
    this.$refs.new_password.focus();
    this.checkToken(this.userId, this.token);
  },
  watch: {
    newPassword(newPassword) {
      this.checkNewPasswordValidity(newPassword);
    },

  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    async checkNewPasswordValidity(newPassword) {
      // Check if the provided password complies with the password policy
      try {
        const response = await fetch(`${API_BASE_URL}/validate-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify({password: newPassword}),
          credentials: 'include',
        });
        const data = await response.json();
        if (data.status !== 'valid') {
          this.newPasswordValidationError = data.errors[0];
        } else {
          this.newPasswordValidationError = '';
        }
      } catch (error) {
        console.error('Error validating new password:', error);
        this.newPasswordValidationError = 'Error validating new password';
      }
    },
    async submitForm() {
      try {
        const response = await fetch(`${API_BASE_URL}/confirm-password-reset/${this.userId}/${this.token}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          credentials: 'include',
          body: JSON.stringify({new_password: this.newPassword}),
        });
        const result = await response.json();
        if (response.ok) {
          // Redirect to login page
          this.$router.push({
            path: '/login',
            query: {success: `Password for user '${this.userName}' updated successfully`}
          });
        } else {
          alert(result.message);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
    async checkToken(userId, token) {
      try {
        const response = await fetch(`${API_BASE_URL}/verify-token/${userId}/${token}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          credentials: 'include',
        });
        const result = await response.json();
        console.log('Token verification result:', result);
        if (result.status === "invalid") {
          console.log('Invalid token!!!');
          this.$router.push({path: '/', query: {warning: "Token is expired or invalid"}});
        } else {
          // Token is valid - Show the form
          console.log('Token is valid');
          this.userName = result.userName;
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
  },
}
</script>